<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8" v-if="application.applicationType === 'platform'">
            <a-form-item :label="language['premission.applicationName']">
              <a-select v-model="queryParam.applicationId" allowClear :placeholder="language['premission.mustApplication']">
                <a-select-option v-for="(application,index) in applicationList" :key="index.toString()" :value="application.id">
                  {{ application.applicationName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['announcement.header']">
              <a-input :placeholder="language['common.pleaseInput']+language['announcement.header']" v-model="queryParam.esTitle"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['announcement.msgContent']">
              <a-input :placeholder="language['common.pleaseInput']+language['announcement.msgContent']" v-model="queryParam.esContent"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="8">
              <a-form-item :label="language['announcement.esReceiver']">
                <a-input :placeholder="language['common.pleaseInput']+language['announcement.esReceiver']" v-model="queryParam.esReceiver"></a-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? language['common.foldButton'] : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" v-show="show" type="primary" icon="plus" v-has="'sysMessage:insert'">{{language['common.insertButton']}}</a-button>
      <!--<a-button type="primary" v-show="show" icon="download" @click="handleExportXls('消息')">导出</a-button>
      <a-upload v-show="show" name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl"
                @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <a-dropdown v-if="selectedRowKeys.length > 0" v-has="'sysMessage:delete'">
        <a-menu slot="overlay" v-has="'sysMessage:delete'">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete"/>
            {{language['common.delete']}}
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}}
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{
        selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <!-- 字符串超长截取省略号显示-->
        <span slot="esContent" slot-scope="text">
          <j-ellipsis :value="text" :length="40" />
        </span>

        <span slot="action" slot-scope="text, record">
          <a href="javascript:;" @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
          <a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}}<a-icon type="down"/></a>
            <a-menu slot="overlay" v-has="'sysMessage:edit'">
               <a-menu-item v-show="show">
                <a  @click="handleEdit(record)">{{language['common.edit']}}</a>
              </a-menu-item>
              <a-menu-item v-has="'sysMessage:delete'">
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <sysMessage-modal ref="modalForm" @ok="modalFormOk"></sysMessage-modal>
  </a-card>
</template>

<script>
  import SysMessageModal from './modules/SysMessageModal'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import JEllipsis from "@/components/jeecg/JEllipsis";
  import { getAction,putAction,httpAction  } from '@/api/manage'

  export default {
    name: "SysMessageList",
    mixins: [JeecgListMixin],
    components: {
      JEllipsis,
      SysMessageModal
    },
    data() {
      return {
        description: '消息管理页面',
        // 新增修改按钮是否显示
        show: false,
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: this.$store.getters.language['announcement.header'],
            align: "center",
            dataIndex: 'esTitle',
            width: 180,
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
          {
            title: this.$store.getters.language['announcement.msgContent'],
            align: "center",
            dataIndex: 'esContent',
            width: 350,
            scopedSlots: {customRender: 'esContent'},
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
          {
            title: this.$store.getters.language['announcement.esReceiver'],
            align: "center",
            dataIndex: 'esReceiver',
            width: 350,
            scopedSlots: {customRender: 'esContent'},
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
          {
            title: this.$store.getters.language['announcement.esSendNum'],
            align: "center",
            dataIndex: 'esSendNum'
          },
          {
            title: this.$store.getters.language['announcement.esSendStatus'],
            align: 'center',
            dataIndex: 'esSendStatus_dictText'
          },
          {
            title: this.$store.getters.language['announcement.esSendTime'],
            align: "center",
            dataIndex: 'esSendTime'
          },
          {
            title: this.$store.getters.language['announcement.esType'],
            align: 'center',
            dataIndex: 'esType_dictText'
          },
          {
            title: this.$store.getters.language['common.action'],
            dataIndex: 'action',
            align: "center",
            scopedSlots: {customRender: 'action'},
          }
        ],
        url: {
          list: this.$store.getters.application.applicationType=='platform'?"/sys/message/sysMessage/list":"/sys/message/sysMessage/list?applicationId="+this.$store.getters.application.id,
          delete: "/sys/message/sysMessage/delete",
          deleteBatch: "/sys/message/sysMessage/deleteBatch",
          exportXlsUrl: "sys/message/sysMessage/exportXls",
          importExcelUrl: "sys/message/sysMessage/importExcel",
        },
        application:{},
        applicationList:[],
      }
    },
    created () {
      this.application = this.$store.getters.application;
      if(this.application.applicationType === 'platform') {
        this.getApplicationList();
      }
      console.log('applicationCode:'+this.$store.getters.applicationCode)
      console.log('applicationtype:'+this.$store.getters.application.applicationType)
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      handleDetail:function(record){
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title=this.language["common.detailsButton"];
        this.$refs.modalForm.disableSubmit = true;
      },
      handleEdit: function (record) {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = this.language["common.edit"]
        this.$refs.modalForm.disableSubmit = false;
      },
      //初始化应用数据
      /*getThisapplication(){
        let param = {}
        param.code = this.$store.getters.applicationCode
        getAction("/sys/sysBmApplication/queryByCode", param).then((res) => {
          if (res.success) {
            this.application = res.result;
            if(res.result.applicationType === 'platform'){
              this.getApplicationList();
            }else{
              queryParam.applicationId=res.result.id
            }
          }
        })
      },*/
      getApplicationList(){
        httpAction("/sys/sysBmApplication/queryList", "", "get").then((res) => {
          if (res.success) {
            this.applicationList = res.result;
          }
        })
      },
    }
  }
</script>
<style lang="less" scoped>
  /** Button按钮间距 */
  .ant-btn {
    margin-left: 3px
  }

  .ant-card-body .table-operator {
    margin-bottom: 18px;
  }

  .ant-table-tbody .ant-table-row td {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .anty-row-operator button {
    margin: 0 5px
  }

  .ant-btn-danger {
    background-color: #ffffff
  }

  .ant-modal-cust-warp {
    height: 100%
  }

  .ant-modal-cust-warp .ant-modal-body {
    height: calc(100% - 110px) !important;
    overflow-y: auto
  }

  .ant-modal-cust-warp .ant-modal-content {
    height: 90% !important;
    overflow-y: hidden
  }
</style>